import { createAsyncThunk } from "@reduxjs/toolkit"
import { asyncThunkWrapper } from "../thunkHandler"
import { BASEURI } from "../../utils/helper"

// Handle retrieve all FAQs
export const retrieveAllFaqs = createAsyncThunk(
  "retrieveAll",
  async (data, thunkAPI) => {
    const params = {
      limit: data?.limit || null,
      search: data?.search || null,
      currentPage: data?.currentPage || null,
    }

    return asyncThunkWrapper(
      {
        params,
        method: "GET",
        url: `${BASEURI}/public/faq/retrieve-all`,
      },
      thunkAPI,
      { toast: false }
    )
  }
)